/*
 * 入力ステップを 10 → 6 に短縮した構成。
 * `sections` は「この画面がまとめて描画する旧カード ID」。旧 URL の振り替え
 * （middleware/legacyFormatCardRedirect）と各カードの表示判定
 * （utils/format-edit/cardSections）が同じ定義を参照する。
 */
export default [
  {
    id: 'basic-info',
    title: '基本情報',
    sections: ['profile', 'address', 'contacts', 'id-photo'],
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-job-history',
    title: '学歴・職歴',
    sections: ['edu-history', 'job-history'],
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'license-history',
    title: '免許・資格',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reason',
    title: '志望動機',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'others',
    title: '通勤時間ほか',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'requests',
    title: '本人希望欄',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'confirm',
    title: '確認',
    sections: ['create-date'],
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
